import * as React from 'react'
import { default as BannerModel } from '../../models/banner'
import './Banner.scss'
import { getBannerUrl } from '../../features/interstitial'
import { Link } from '../link'
import classnames from 'classnames'

export type FieldProps = {
  banner: BannerModel
  className?: string
  userId?: string | undefined
}

type Props = FieldProps

class Banner extends React.Component<Props> {
  render() {
    const { banner, userId } = this.props
    const url =
      banner.slug === undefined
        ? ''
        : process.env.REACT_APP_INTERSTITIAL_PAGE === 'true'
          ? getBannerUrl(banner.slug)
          : banner.target !== undefined
            ? !banner.target.startsWith('https://')
              ? 'https://'
              : '' + banner.target + (userId ? '/?userId=' + userId : '')
            : getBannerUrl(banner.slug)

    let bannerTypeClass
    switch (banner.type) {
      case 'CATEGORY_LEADERBOARD':
      case 'SUB_CATEGORY_LEADERBOARD':
      case 'HOME_HEADER':
        bannerTypeClass = 'banner-home-header'
        break
      case 'HOME_CAROUSEL':
        bannerTypeClass = 'banner-home-carousel banner-carousel'
        break
      case 'HOME_MIDWAY_AD':
        bannerTypeClass = 'banner-home-midway-ad'
        break
      case 'CATEGORY_HEADER':
        bannerTypeClass = 'banner-category-header banner-carousel'
        break
      default:
        break
    }
    const classes = classnames('banner', bannerTypeClass)

    return (
      <Link
        className={classes}
        to={url}
        target='_blank'
        data-banner-id={banner.id}
      >
        <picture>
          <source
            srcSet={banner.desktopImage}
            media='(min-width: 960px)'
          />
          <source
            srcSet={banner.tabletImage}
            media='(min-width: 415px)'
          />
          <img
            srcSet={banner.mobileImage}
            alt={banner.alt}
            className='banner__image'
          />
        </picture>
      </Link>
    )
  }
}

export default Banner
